"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasCoreMembership = exports.CORE_MEMBERSHIP_NAME = void 0;
// This util was originally used to grant temporary benefits for Legacy Freemium users
// but we can slowly replace with just checking isCoreMembership
var hasCoreMembership = function hasCoreMembership(membership) {
  return !!(membership !== null && membership !== void 0 && membership.isCoreMembership);
};

// Only used for text that the end-user sees, like the Monument application or emails.
// In code, comments, event names, etc. just write out the string literal 'Core Membership'
exports.hasCoreMembership = hasCoreMembership;
var CORE_MEMBERSHIP_NAME = 'Community Membership';
exports.CORE_MEMBERSHIP_NAME = CORE_MEMBERSHIP_NAME;